import { reactive, watch } from 'vue'

const storedCart = localStorage.getItem('user_cart')
let initialCart = []
if (storedCart) {
    try {
        initialCart = JSON.parse(storedCart)
    } catch(e) { console.error(e); }
}

const store = reactive({
  user: {
    token: localStorage.getItem('user_token') || null,
    info: JSON.parse(localStorage.getItem('user_info')) || null
  },
  cart: initialCart,
  theme: 'light',
  isAuthModalOpen: false,
  isCartSidebarOpen: false,

  // Methods
  login(token, userInfo) {
    this.user.token = token
    this.user.info = userInfo
    localStorage.setItem('user_token', token)
    localStorage.setItem('user_info', JSON.stringify(userInfo))
  },

  logout() {
    this.user.token = null
    this.user.info = null
    localStorage.removeItem('user_token')
    localStorage.removeItem('user_info')
  },

  addToCart(item) {
    // Basic deduplication or stacking logic can be added later
    this.cart.push(item)
    this.saveCart()
  },

  removeFromCart(index) {
    this.cart.splice(index, 1)
    this.saveCart()
  },

  clearCart() {
    this.cart = []
    this.saveCart()
  },

  saveCart() {
     localStorage.setItem('user_cart', JSON.stringify(this.cart))
  }
})

watch(() => store.cart, () => {
    store.saveCart()
}, { deep: true })

export default store
